import { render, staticRenderFns } from "./SuggestTerm.vue?vue&type=template&id=07829c06&scoped=true&"
import script from "./SuggestTerm.vue?vue&type=script&lang=js&"
export * from "./SuggestTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07829c06",
  null
  
)

export default component.exports